import React, {Fragment, useState, useEffect} from 'react';
import RNUFormService from "../../../../services/RNUFormService";
import {CHECK_IMG} from "../../../../constants";
import NumberFormat from "react-number-format";
import Color from "color";

const TemplateDPUSynthese = (props) => {

    const rnuFormService = new RNUFormService()
    const [dpuCom, setDpuCom] = useState()
    const [dpuParcelle, setDpuParcelle] = useState()
    const fetchData = rnuFormService.getData('preemption')
    const fetchData2 = rnuFormService.getData('preemption_com')
    const refDocType1 = [
        {"name":'DPU(s)', "labelle": 'Droit de préemption simple'},
        {"name":'DPU(r)', "labelle": 'Droit de préemption renforcé'},
        //{"name":'DPFC', "labelle": 'Droit de préemption sur les cessions de commerce'},
        {"name":'ENS', "labelle": 'Droit de préemption sur les espaces naturels sensibles'},
        {"name":'ZAD', "labelle": 'Droit de préemption dans une zone d\'aménagement differé'},
        {"name":'ZAC', "labelle": 'Droit de préemption dans les zones d\'aménagement concerté'},
        {"name":'SAFER', "labelle": 'Les droits de préemption de la SAFER s\'appliquent en cas de vocation agricole (article L. 143-1 du code rural de la pêche maritime) et/ou en cas de parcelle enclavée au sens de l\'article 682 du code civil'},
    ]

    useEffect(()=>{
        //check DPU PARCELLES
        (fetchData)?
            refDocType1.map((item, index) => {
                let result = _.findIndex(fetchData, (o)=>{return o.libelle_1 == item.name });
                 (result>=0)?setDpuParcelle(true):null;
            })
            :null

    },[fetchData])

    useEffect(()=>{
        (fetchData2)?
            fetchData2.map(item=>{
                (item.code=='2'||item.code==2)?setDpuCom(true):null;
            })
            :null

    },[fetchData2])


    const checkCommuneDpu = ()=>{

    }

    return (
        <div className="ue-section ue-synthese">
            <table className={"ue-form-table-row"} style={{"border":"none"}}>
                <thead >
                <tr className={"ue-table-row-header"}>
                    <th style={{"width": "50px"}}>Synthèse</th>
                    <th></th>
                    <th style={{"width": "30px"}}></th>
                </tr>
                </thead>
                <tbody>
                <tr style={{"borderBottom": "1px solid #ccc"}}>
                    <td >
                        DPU
                    </td>
                    <td>
                        <span style={{"whiteSpace": "pre-warp"}} >
                            Commune soumise à un droit de préemption
                        </span>
                    </td>
                    <td className={'text-center'} style={{verticalAlign: 'middle'}}>
                        {
                            (dpuCom)
                                ?<img src={CHECK_IMG} alt="Oui" height="15"/>
                                : '-'
                        }
                    </td>
                </tr>
                <tr style={{"borderBottom": "1px solid #ccc"}}>
                    <td >
                        DPU
                    </td>
                    <td>
                        <span style={{"whiteSpace": "pre-warp"}} >
                            Le bien est-il dans périmètre de droit de préemption
                        </span>
                    </td>
                    <td className={'text-center'} style={{verticalAlign: 'middle'}}>
                        {
                            (dpuParcelle)
                                ?<img src={CHECK_IMG} alt="Oui" height="15"/>
                                : '-'
                        }
                    </td>
                </tr>
                </tbody>
            </table>
            <br/>
        </div>
    );
};

export default TemplateDPUSynthese;
